import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import actions from './actions'
import selectors from './selectors'
import { join } from 'path';

class Publications extends Component {
    componentDidMount() {
        this.props.fetchData();
    }
    render() {
        const {publications} = this.props;
        return (
            <div>
                {publications.map((pub, i) => {
                    return (
                        <p key={i} className="publication">
                            {Object.values(pub).map((val, j) => <span key={j}>{val}</span>)}
                        </p>
                    )
                })}
            </div>
        )
    }
}

export default connect(selectors, actions)(Publications);


// WEBPACK FOOTER //
// ./src/modules/Publications/container.js